// extracted by mini-css-extract-plugin
module.exports = {"navigation":"Navigation-module--navigation--3BxII","navigationItem":"Navigation-module--navigationItem--GzDAU"};